import { RefObject, useEffect, useLayoutEffect, useRef, useState } from 'react';

export const useElementDimensions = (
  svgContainerRef: RefObject<HTMLDivElement | null>,
) => {
  const [containerWidth, setContainerWidth] = useState<number>(0);
  const [containerHeight, setContainerHeight] = useState<number>(0);

  const lastContainerWidthRef = useRef<number>(0);
  const lastContainerHeightRef = useRef<number>(0);

  useEffect(() => {
    const containerClientWidth = svgContainerRef.current?.clientWidth;
    const containerClientHeight = svgContainerRef.current?.clientHeight;
    if (!lastContainerWidthRef.current && containerClientWidth) {
      setContainerWidth(containerClientWidth);
    }
    if (!lastContainerHeightRef.current && containerClientHeight) {
      setContainerHeight(containerClientHeight);
    }
  }, [svgContainerRef]);

  useLayoutEffect(() => {
    const svgContainer = svgContainerRef.current;
    if (svgContainer) {
      const resizeObserver = new ResizeObserver((entries) => {
        const newWidth = Math.round(entries[0].contentRect.width);
        const newHeight = Math.round(entries[0].contentRect.height);
        if (newWidth !== lastContainerWidthRef.current) {
          lastContainerWidthRef.current = newWidth;
          setContainerWidth(newWidth);
        }
        if (newHeight !== lastContainerHeightRef.current) {
          lastContainerHeightRef.current = newHeight;
          setContainerHeight(newHeight);
        }
      });

      resizeObserver.observe(svgContainer);

      return () => {
        resizeObserver.unobserve(svgContainer);
      };
    }
  }, [svgContainerRef]);

  return { width: containerWidth, height: containerHeight };
};
